export const Mensaje = ({ mensaje, icono }) => {
    return (
        <div className="flex flex-col gap-4">
            <img className="max-w-48 mx-auto" src={icono} alt={mensaje} />
            <p className="text-white font-semibold text-xl text-center">{mensaje}</p>
        </div>
    )
}
